import config from "@/config";

/**
 * getUrlParameters
 * @description converts url-like string to object
 *   e.g.
 *     /?client=something&other=value => { client: something, other: value }
 *
 * @param url {String}
 * @return parameters {Object}
 */
function getUrlParameters(url) {
  return url
    .slice(1)
    .split("&")
    .reduce((obj, string) => {
      let arr = string.split("=");

      let key = arr[0];
      let value = arr[1];

      if (!obj[key]) {
        obj[key] = value;
      }
      return obj;
    }, {});
}

function validateTenantId(tenantId) {
  return config.validTenantIds.some(id => id === tenantId);
}

export { getUrlParameters, validateTenantId };



// WEBPACK FOOTER //
// ./src/lib/utils.js